/**
 * @generated SignedSource<<1c737eb2cabaf0ab5ddf226de7047dad>>
 * @relayHash 99c9b559039c583547ef40e7402826a6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cea427276cf747ecdd5141ecc68b95890eaafd7ffc2a1a5f883ee10092d34ab1

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useAccessClassTransformerQuery$variables = {
  cloudId: string;
};
export type useAccessClassTransformerQuery$data = {
  readonly confluence_userClasses: {
    readonly nodes: ReadonlyArray<{
      readonly displayName: string;
      readonly principalId: string;
    }> | null | undefined;
  } | null | undefined;
};
export type useAccessClassTransformerQuery = {
  response: useAccessClassTransformerQuery$data;
  variables: useAccessClassTransformerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "ConfluenceUserClassConnection",
    "kind": "LinkedField",
    "name": "confluence_userClasses",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceUserClass",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "principalId"
          },
          {
            "kind": "ScalarField",
            "name": "displayName"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useAccessClassTransformerQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAccessClassTransformerQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "99c9b559039c583547ef40e7402826a6",
    "id": "cea427276cf747ecdd5141ecc68b95890eaafd7ffc2a1a5f883ee10092d34ab1",
    "metadata": {},
    "name": "useAccessClassTransformerQuery",
    "operationKind": "query",
    "text": "query useAccessClassTransformerQuery($cloudId:ID!){confluence_userClasses(cloudId:$cloudId){nodes{principalId,displayName}}}"
  }
};
})();

(node as any).hash = "a336baeeba530d71a57fedc023a9b7eb";

export default node;
